<script lang="ts">
	import { PUBLIC_SITEMAP_URL } from '$env/static/public';
	import type { LANGUAGE } from '$lib/constants/locale';
	import { LINK_PRIVACY_POLICY, LINK_ROOT, LOCALIZELINK } from '$utils/link';
	import { getContext } from 'svelte';
	import SeoMetadata from '$components/atoms/SeoMetadata.svelte';
	import type { SeoMetadataType, PagesType } from '$types/seo.types';
	import LdTagV2 from '$components/Ldjson/LdTagV2.svelte';

	const seoMetadata = getContext('seo-metadata') as Record<PagesType, SeoMetadataType>;

	const privacyPolicy = getContext('page-contents-privacy-policy') as Record<
		string,
		string | Record<string, string>
	>;
	let lang = getContext('lang') as LANGUAGE;
</script>

<SeoMetadata data={seoMetadata['privacyPolicy']} link={LINK_PRIVACY_POLICY} />
<LdTagV2 schema={seoMetadata['privacyPolicy'].schemaJson} />
<div class="py-15 bg-grey-100 dark:bg-grey-800 px-4">
	<div class="mx-auto max-w-[1120px]">
		<div class="karla-medium-4xl text-grey-800 mb-10 dark:text-white">
			{privacyPolicy.privacyPolicy_title}
		</div>
		<section>
			<div class="flex items-center justify-start gap-4">
				<div class="numbering">1</div>
				<div class="dark:text-white">
					{privacyPolicy.privacyPolicy_introduction_title}
				</div>
			</div>
			<p>
				{privacyPolicy.privacyPolicy_introduction_text}
			</p>
			<div class="mt-20 flex items-center justify-start gap-4">
				<div class="numbering">2</div>
				<div class="dark:text-white">
					{privacyPolicy.privacyPolicy_collectedInformation_title}
				</div>
			</div>
			<p>
				{privacyPolicy.privacyPolicy_collectedInformation_text1}
				<br />
				<br />
				{privacyPolicy.privacyPolicy_collectedInformation_text2}
				<br />
				<br />
				{privacyPolicy.privacyPolicy_collectedInformation_text3}
				<br />
				<br />
				{privacyPolicy.privacyPolicy_collectedInformation_text4}
				<br />
				<br />
				{privacyPolicy.privacyPolicy_collectedInformation_text5}
			</p>
			<div class="text-linear-purple-100 karla-medium-xl mt-20">
				{privacyPolicy.privacyPolicy_notifications_title}
			</div>
			<p>
				{privacyPolicy.privacyPolicy_notifications_text}
			</p>
			<ol>
				<li>
					{privacyPolicy.privacyPolicy_notifications_list1}
				</li>
				<li>
					{@html privacyPolicy.privacyPolicy_notifications_list2}
				</li>
			</ol>
		</section>
		<a
			href={LOCALIZELINK(lang, LINK_ROOT)}
			class="mx-auto block max-w-[360px]"
			aria-label="Go to home"
		>
			<button
				class="bg-linear-purple-100 karla-bold rounded-5px mt-10 h-12 w-full text-lg text-white"
				aria-label="Go to home"
			>
				GO TO HOME
			</button>
		</a>
	</div>
</div>

<style lang="postcss">
	.numbering {
		@apply w-38px h-38px bg-linear-purple-100 karla-medium-2xl flex items-center justify-center rounded-full text-white;
	}
	p {
		@apply rubik-regular-sm text-grey-800 mt-3 text-justify;
	}
	:global(.dark) p {
		@apply text-white;
	}
	ol {
		@apply list-inside list-decimal;
	}
	li {
		@apply rubik-regular-sm text-grey-800 mt-3;
	}
	:global(.dark) li {
		@apply text-white;
	}
</style>
